import React, {Component} from 'react';
import css from './FieldScoreboard.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import axios from "axios";
import _ from 'lodash';


/**
 * @class
 *
 * FieldScoreboard page.
 */
const FieldScoreboard = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    // ---------- state: ----------
    state = {
        lastWeek: [],
        thisMonth: [],
        lastMonth: []
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        this.getFieldScoreboardData();
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getFieldScoreboardData = () => {
        axios.get(
            '/getHMODScoreboard',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const kpis = res.data[0]

                this.aggregateKPIData(kpis.kpis.install);
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in HMOD Scoreboard: \n', err);
                }
            });
    };

    aggregateKPIData = (kpis) => {
        let lastWeekArray = [];
        let thisMonthArray = [];
        let lastMonthArray = [];

        _.forEach(kpis.lastWeekInstallData, function(value) {
            let hours = value.regularHours + value.otHours * 2;
            let data = {name: value.name, regularHours: value.regularHours ? value.regularHours.toFixed(2) : 0, otHours: value.otHours ? value.otHours.toFixed(2) : 0, hrsPerModule: value.panelCount === 0 ? 0 : (hours.toFixed(2) / value.panelCount).toFixed(2), panelCount: value.panelCount};
            lastWeekArray.push(data);
        });

        _.forEach(kpis.thisMonthInstallData, function(value) {
            let hours = value.regularHours + value.otHours * 2;
            let data = {name: value.name, regularHours: value.regularHours ? value.regularHours.toFixed(2) : 0, otHours: value.otHours ? value.otHours.toFixed(2) : 0, hrsPerModule: value.panelCount === 0 ? (0).toFixed(2) : (hours / value.panelCount).toFixed(2), panelCount: value.panelCount};
            thisMonthArray.push(data);
        });

        _.forEach(kpis.lastMonthInstallData, function(value) {
            let hours = value.regularHours + value.otHours * 2;
            let data = {name: value.name, regularHours: value.regularHours ? value.regularHours.toFixed(2) : 0, otHours: value.otHours ? value.otHours.toFixed(2) : 0, hrsPerModule: value.panelCount === 0 ? (0).toFixed(2) : (hours / value.panelCount).toFixed(2), panelCount: value.panelCount};
            lastMonthArray.push(data);
        });

        this.setState({
            lastWeek: _.filter(lastWeekArray, function(o) { return o.hrsPerModule != 0; }).sort((a, b) => a.hrsPerModule - b.hrsPerModule),
            thisMonth: _.filter(thisMonthArray, function(o) { return o.hrsPerModule != 0; }).sort((a, b) => a.hrsPerModule - b.hrsPerModule),
            lastMonth: _.filter(lastMonthArray, function(o) { return o.hrsPerModule != 0; }).sort((a, b) => a.hrsPerModule - b.hrsPerModule)
        });
    };

    render() {
        return (
            <div className={css.FieldScoreboard}>
                <SectionHeading heading="HMOD Scoreboard" />
                <br></br>

                <h2>Last Week Performance</h2>
                <div className="d-none d-md-block">
                    <table>
                        <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team</th>
                            <th>Hours</th>
                            <th>OT Hours</th>
                            <th>Modules</th>
                            <th>Hours/Module</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.lastWeek.map((fieldTech, index) =>
                                <tr key={fieldTech.id}>
                                    <td>{index+1}</td>
                                    <td>{fieldTech.name}</td>
                                    <td>{fieldTech.regularHours} <div className="d-md-none">{fieldTech.otHours}</div></td>
                                    <td className="d-md-block d-none">{fieldTech.otHours}</td>
                                    <td>{fieldTech.panelCount}</td>
                                    <td>{fieldTech.hrsPerModule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-md-none">
                    <table>
                        <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team</th>
                            <th>Hrs|OT</th>
                            <th>Mds</th>
                            <th>Hrs/Mod</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.lastWeek.map((fieldTech, index) =>
                                <tr key={fieldTech.id}>
                                    <td>{index+1}</td>
                                    <td>{fieldTech.name}</td>
                                    <td>{fieldTech.regularHours} {fieldTech.otHours}</td>
                                    <td>{fieldTech.panelCount}</td>
                                    <td>{fieldTech.hrsPerModule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <br></br>

                <h2>This Month Performance</h2>
                <div className="d-none d-md-block">
                    <table>
                        <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team</th>
                            <th>Hours</th>
                            <th>OT Hours</th>
                            <th>Modules</th>
                            <th>Hours/Module</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.thisMonth.map((fieldTech, index) =>
                                <tr key={fieldTech.id}>
                                    <td>{index+1}</td>
                                    <td>{fieldTech.name}</td>
                                    <td>{fieldTech.regularHours} <div className="d-md-none">{fieldTech.otHours}</div></td>
                                    <td className="d-md-block d-none">{fieldTech.otHours}</td>
                                    <td>{fieldTech.panelCount}</td>
                                    <td>{fieldTech.hrsPerModule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-md-none">
                    <table>
                        <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team</th>
                            <th>Hrs|OT</th>
                            <th>Mds</th>
                            <th>Hrs/Mod</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.thisMonth.map((fieldTech, index) =>
                                <tr key={fieldTech.id}>
                                    <td>{index+1}</td>
                                    <td>{fieldTech.name}</td>
                                    <td>{fieldTech.regularHours} {fieldTech.otHours}</td>
                                    <td>{fieldTech.panelCount}</td>
                                    <td>{fieldTech.hrsPerModule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <br></br>

                <h2>Last Month Performance</h2>
                <div className="d-none d-md-block">
                    <table>
                        <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team</th>
                            <th>Hours</th>
                            <th>OT Hours</th>
                            <th>Modules</th>
                            <th>Hours/Module</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.lastMonth.map((fieldTech, index) =>
                                <tr key={fieldTech.id}>
                                    <td>{index+1}</td>
                                    <td>{fieldTech.name}</td>
                                    <td>{fieldTech.regularHours} <div className="d-md-none">{fieldTech.otHours}</div></td>
                                    <td className="d-md-block d-none">{fieldTech.otHours}</td>
                                    <td>{fieldTech.panelCount}</td>
                                    <td>{fieldTech.hrsPerModule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-md-none">
                    <table>
                        <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Team</th>
                            <th>Hrs|OT</th>
                            <th>Mds</th>
                            <th>Hrs/Mod</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.lastMonth.map((fieldTech, index) =>
                                <tr key={fieldTech.id}>
                                    <td>{index+1}</td>
                                    <td>{fieldTech.name}</td>
                                    <td>{fieldTech.regularHours} {fieldTech.otHours}</td>
                                    <td>{fieldTech.panelCount}</td>
                                    <td>{fieldTech.hrsPerModule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <br></br>
            </div>
        );
    };
};

export default FieldScoreboard;
